@use '@fpsm/cxy-scss' as cxy;

.rangeSelectFilterContainer {
  @include cxy.stack(var(--cxy-spacing-xxxsm));
}

.rangeSelectFilterLabel {
  font-size: var(--cxy-fontSize-s);
}

.rangeSelectFilterItems {
  display: flex;
  gap: var(--cxy-spacing-xsm);
}

.rangeSelectFilterItem {
  flex: 1;
}
